module.exports = __webpack_public_path__ + "img/lose_lottery3_small.ecb279a0.png";